import axios from "axios";
import { stage_url } from "../api-urls";
import Headers from "./Headers";

export async function GetUsers(payload) {
    return await axios.get(
        `${stage_url}api-business-v3/user/all`,
        {
            params: payload,
            headers: Headers.getHeaders(true),
        }
    );
}


export async function SearchUser(payload) {
    return await axios.get(
        `${stage_url}api-business-v3/user/search`,
        {
            params: payload,
            headers: Headers.getHeaders(true),
        }
    );
}



export async function BlocknUnblockUser(user_id) {
    return await axios.get(
        `${stage_url}api-business-v3/user/block?userId=${user_id}`,
        {
            headers: Headers.getHeaders(true),
        }
    );
}

export async function GetInoiceCount(user_id) {
    return await axios.get(
        `${stage_url}api-business-v3/user/count/invoice?userId=${user_id}`,
        {
            headers: Headers.getHeaders(true),
        }
    );
}

export async function GetStocksCount(user_id) {
    return await axios.get(
        `${stage_url}api-business-v3/user/count/stocks?userId=${user_id}`,
        {
            headers: Headers.getHeaders(true),
        }
    );
}